import React, { useEffect, useState } from 'react';
import {
  fmpAssetSEReviewExcelDownload,
  fmpAssetPCEReviewExcelDownload,
  getFmpErrors,
  getFmpAssets_SE,
  getFmpAssets_PCE,
  saveFmpAssets
} from '../../../api';
import {Tabs, Checkbox, Col, Row, Table, Select} from 'antd';
import './assettable.css';

import FMPDTAssetFileExport from './FMPDTAssetFileExport';
import MultiselectExtension from "../../../components/MultiselectExtension";
import Accordion from "../../../components/Accordion/Accordion";

function AssetReview({ project, tracksData, lcraStatus, onAddClick, onDataRefreshed, handleProjectDetailUpdate
                     }) {
  const [seAssets, setSeAssets] = useState([]);
  const [pceAssets, setPceAssets] = useState([]);
  const [fmpErrors, setFmpErrors] = useState([]);

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [refresh, setRefresh] = useState(true);
  const { Option } = Select;
  const { TabPane } = Tabs;
  
  const handleMultiChangeErrors = (record, selectedItem) => {
    projectInfo.fmpErrorList = selectedItem;
    updateFmpAssets(record, true).then(r => setRefresh(true));
  };

  const handleResetChangeErrors = (record, selectedItem) => {
    projectInfo.fmpErrorList = [];
    updateFmpAssets(record, true).then(r => setRefresh(true));
  };

  async function updateFmpAssets(record, isErrorListUpdated) {
    projectInfo.objectId = record.objectId;
    projectInfo.fmpDifference = record.fmpDifference !== null ? record.fmpDifference : "N";
    projectInfo.ipsDifference = record.ipsDifference !== null ? record.ipsDifference : "N";
    if(!isErrorListUpdated) {
      const aggregatedFmpErrors = record.aggregatedFmpErrors;
      projectInfo.fmpErrorList = aggregatedFmpErrors
          ? fmpErrors.filter(entity =>
              aggregatedFmpErrors.split(',').some(id => parseInt(id.trim(), 10) === entity.fmpErrorId)
          ) : [];
    }
    await saveFmpAssets(projectInfo);
  }

  let projectInfo = {
    bpid: project.bpid,
    workOrder: project.workOrder,
    stationName: project.stationName,
    objectId: null,
    fmpDifference: null,
    ipsDifference: null,
    fmpErrorList: []
  };
  useEffect(() => {
    async function getData() {
      let seAssets = await getFmpAssets_SE(projectInfo);
      setSeAssets(seAssets);
      let pceAssets = await getFmpAssets_PCE(projectInfo);
      setPceAssets(pceAssets);
      let fmpErrorEntities = await getFmpErrors();
      setFmpErrors(fmpErrorEntities);
      setRefresh(false);
    }
       if (refresh) getData();
  }, [refresh]);

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  function composeFilters(fieldName, assets) {
    let filters = [...new Set(assets.map((asset) => asset[fieldName]))];
    let filtersSort = filters.map((distinctFilters) => ({
      text: distinctFilters,
      value: distinctFilters,
    }));
    filtersSort.sort((a, b) => {
      a = a.text || '';
      b = b.text || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });

    return filtersSort;
  }

  function multipleSort(compFunctions) {
    return function (a, b) {
      for (const func of compFunctions) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
    };
  }

  const iPSComp = (a, b) => {
    a = a.ipsLocationName || '';
    b = b.ipsLocationName || '';

    return b.localeCompare(a);
  };
  const assetNameComp = (a, b) => {
    a = a.assetName || '';
    b = b.assetName || '';

    return b.localeCompare(a);
  };
  const toggleFmpCheckbox = (text, record) => {
    record.fmpDifference = text === 'Y' ? 'N' : 'Y';
    updateFmpAssets(record, false).then(r => setRefresh(true));
  };
  const toggleIpsCheckbox = (text, record) => {
    record.ipsDifference = text === 'Y' ? 'N' : 'Y';
    updateFmpAssets(record, false).then(r => setRefresh(true));
  };


  const seColumns = [
    {
      dataIndex: 'assetName',
      width: '15%',
      key: 'assetName',
      title: 'Asset Name',
      filters: composeFilters('assetName', seAssets),
      fixed: 'left',
      filteredValue: filteredInfo.assetName || null,
      onFilter: (value, record) => record.assetName === value,
      sorter: (a, b) => {
        a = a.assetName || '';
        b = b.assetName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetName' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'assetGroupName',
      width: '7%',
      key: 'assetGroupName',
      title: 'Asset Group',
      filters: composeFilters('assetGroupName', seAssets),
      filteredValue: filteredInfo.assetGroupName || null,
      onFilter: (value, record) => record.assetGroupName === value,
      sorter: (a, b) => {
        a = a.assetGroupName || '';
        b = b.assetGroupName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetGroupName' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'assetType',
      width: '10%',
      key: 'assetType',
      title: 'Asset Type',
      filters: composeFilters('assetType', seAssets),
      filteredValue: filteredInfo.assetType || null,
      onFilter: (value, record) => record.assetType === value,
      sorter: (a, b) => {
        a = a.assetType || '';
        b = b.assetType || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetType' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: "fmpDifference",
      width: "6%",
      key: "fmpDifference",
      title: "FMP Difference",
      filters: composeFilters('fmpDifference', seAssets),
      filteredValue: filteredInfo?.fmpDifference || null,
      onFilter: (value, record) => record.fmpDifference === value,
      sorter: (a, b) => {
        const first = a.fmpDifference || "";
        const second = b.fmpDifference || "";
        return first.toLowerCase().localeCompare(second.toLowerCase());
      },
      sortOrder: sortedInfo?.columnKey === "fmpDifference" && sortedInfo?.order,
      render: (text, record) => (
          <Checkbox
              checked={text === 'Y'}
              onChange={() => toggleFmpCheckbox(text, record)}
              style={{ transform: "scale(1)" }}
          />
      ),
    },
    {
      dataIndex: "aggregatedFmpErrors",
      width: "12%",
      key: "aggregatedFmpErrors",
      title: "FMP Errors Found",
      filters: composeFilters("aggregatedFmpErrors", pceAssets),
      filteredValue: filteredInfo?.aggregatedFmpErrors || null,
      onFilter: (value, record) => record.aggregatedFmpErrors === value,
      sorter: (a, b) => {
        a = a.aggregatedFmpErrors || "";
        b = b.aggregatedFmpErrors || "";
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo?.columnKey === "aggregatedFmpErrors" && sortedInfo?.order,
      render: (text, record) => {

        return (
            <Col xs={24} md={24} lg={24}>
              <MultiselectExtension options={fmpErrors}
                                    selectedValues={text !== null ?
                                        fmpErrors.filter(entity => text.split(',').map(id => parseInt(id.trim(), 10)).includes(entity.fmpErrorId)) : []}
                                    onSelect={(selectedItem) => handleMultiChangeErrors(record, selectedItem)}
                                    onRemove={(selectedItem) => handleMultiChangeErrors(record, selectedItem)}
                                    showCheckbox={true}
                                    displayValue="fmpErrorName"
                                    placeholder={fmpErrors !== null ?
                                        fmpErrors : 'Select FMP Errors'}
                                    resetSelectField={(selectedItem) => handleResetChangeErrors(record, selectedItem)}
              />
            </Col>
        );
      },
    },
    {
      dataIndex: 'ipsDifference',
      width: '6%',
      key: 'ipsDifference',
      title: 'IPS Difference',
      filters: composeFilters('ipsDifference', seAssets),
      filteredValue: filteredInfo.ipsDifference || null,
      onFilter: (value, record) => record.ipsDifference === value,
      sorter: (a, b) => {
        a = a.ipsDifference || '';
        b = b.ipsDifference || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'ipsDifference' && sortedInfo.order,
      render: (text, record) => (
          <Checkbox
              checked={text === 'Y'}
              onChange={() => toggleIpsCheckbox(text, record)}
              style={{ transform: 'scale(1)' }}
          />
      ),
    },
    {
      dataIndex: 'ipsLocationName',
      width: '20%',
      key: 'ipsLocationName',
      title: 'IPS Location',
      filters: composeFilters('ipsLocationName', seAssets),
      filteredValue: filteredInfo.ipsLocationName || null,
      onFilter: (value, record) => record.ipsLocationName === value,
      sorter: (a, b) => {
        a = a.ipsLocationName || '';
        b = b.ipsLocationName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'ipsLocationName' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'workOrder',
      width: '8%',
      key: 'workOrder',
      title: 'Install WO#',
      filters: composeFilters('workOrder', seAssets),
      filteredValue: filteredInfo.workOrder || null,
      onFilter: (value, record) => record.workOrder === value,
      sorter: (a, b) => {
        a = a.workOrder || '';
        b = b.workOrder || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'workOrder' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'bpid',
      width: '8%',
      key: 'bpid',
      title: 'Install BPID',
      filters: composeFilters('bpid', seAssets),
      filteredValue: filteredInfo.bpid || null,
      onFilter: (value, record) => record.bpid === value,
      sorter: (a, b) => {
        a = a.bpid || '';
        b = b.bpid || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'bpid' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'internalRef',
      width: '10%',
      key: 'internalRef',
      title: 'IPS Internal Ref. No.',
      filters: composeFilters('internalRef', seAssets),
      filteredValue: filteredInfo.internalRef || null,
      onFilter: (value, record) => record.internalRef === value,
      sorter: (a, b) => {
        a = a.internalRef || '';
        b = b.internalRef || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'internalRef' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'assetStatus',
      width: '8%',
      key: 'assetStatus',
      title: 'IPS Asset Status',
      filters: composeFilters('assetStatus', seAssets),
      filteredValue: filteredInfo.assetStatus || null,
      onFilter: (value, record) => record.assetStatus === value,
      sorter: (a, b) => {
        a = a.assetStatus || '';
        b = b.assetStatus || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetStatus' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
  ];

  const pceColumns = [
    {
      dataIndex: 'assetName',
      width: '15%',
      key: 'assetName',
      title: 'Asset Name',
      filters: composeFilters('assetName', pceAssets),
      fixed: 'left',
      filteredValue: filteredInfo.assetName || null,
      onFilter: (value, record) => record.assetName === value,
      sorter: (a, b) => {
        a = a.assetName || '';
        b = b.assetName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetName' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'assetGroupName',
      width: '7%',
      key: 'assetGroupName',
      title: 'Asset Group',
      filters: composeFilters('assetGroupName', pceAssets),
      filteredValue: filteredInfo.assetGroupName || null,
      onFilter: (value, record) => record.assetGroupName === value,
      sorter: (a, b) => {
        a = a.assetGroupName || '';
        b = b.assetGroupName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetGroupName' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'assetType',
      width: '10%',
      key: 'assetType',
      title: 'Asset Type',
      filters: composeFilters('assetType', pceAssets),
      filteredValue: filteredInfo.assetType || null,
      onFilter: (value, record) => record.assetType === value,
      sorter: (a, b) => {
        a = a.assetType || '';
        b = b.assetType || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetType' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: "fmpDifference",
      width: "6%",
      key: "fmpDifference",
      title: "FMP Difference",
      filters: composeFilters('fmpDifference', pceAssets),
      filteredValue: filteredInfo?.fmpDifference || null,
      onFilter: (value, record) => record.fmpDifference === value,
      sorter: (a, b) => {
        const first = a.fmpDifference || "";
        const second = b.fmpDifference || "";
        return first.toLowerCase().localeCompare(second.toLowerCase());
      },
      sortOrder: sortedInfo?.columnKey === "fmpDifference" && sortedInfo?.order,
      render: (text, record) => (
          <Checkbox
              checked={text === 'Y'}
              onChange={() => toggleFmpCheckbox(text, record)}
              style={{ transform: "scale(1)" }}
          />
      ),
    },
    {
      dataIndex: "aggregatedFmpErrors",
      width: "12%",
      key: "aggregatedFmpErrors",
      title: "FMP Errors Found",
      filters: composeFilters("aggregatedFmpErrors", pceAssets),
      filteredValue: filteredInfo?.aggregatedFmpErrors || null,
      onFilter: (value, record) => record.aggregatedFmpErrors === value,
      sorter: (a, b) => {
        a = a.aggregatedFmpErrors || "";
        b = b.aggregatedFmpErrors || "";
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo?.columnKey === "aggregatedFmpErrors" && sortedInfo?.order,
      render: (text, record) => {
        return (
            <Col xs={24} md={24} lg={24}>
              <MultiselectExtension options={fmpErrors}
                                    selectedValues={text !== null ?
                                        fmpErrors.filter(entity => text.split(',').map(id => parseInt(id.trim(), 10)).includes(entity.fmpErrorId)) : []}
                                    onSelect={(selectedItem) => handleMultiChangeErrors(record, selectedItem)}
                                    onRemove={(selectedItem) => handleMultiChangeErrors(record, selectedItem)}
                                    showCheckbox={true}
                                    displayValue="fmpErrorName"
                                    placeholder={fmpErrors !== null ?
                                        fmpErrors : 'Select FMP Errors'}
                                    resetSelectField={(selectedItem) => handleResetChangeErrors(record, selectedItem)}
              />
            </Col>
        );
      },
    },
    {
      dataIndex: 'ipsDifference',
      width: '6%',
      key: 'ipsDifference',
      title: 'IPS Difference',
      filters: composeFilters('ipsDifference', pceAssets),
      filteredValue: filteredInfo.ipsDifference || null,
      onFilter: (value, record) => record.ipsDifference === value,
      sorter: (a, b) => {
        a = a.ipsDifference || '';
        b = b.ipsDifference || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'ipsDifference' && sortedInfo.order,
      render: (text, record) => (
          <Checkbox
              checked={text === 'Y'}
              onChange={() => toggleIpsCheckbox(text, record)}
              style={{ transform: 'scale(1)' }}
          />
      ),
    },
    {
      dataIndex: 'ipsLocationName',
      width: '20%',
      key: 'ipsLocationName',
      title: 'IPS Location',
      filters: composeFilters('ipsLocationName', pceAssets),
      filteredValue: filteredInfo.ipsLocationName || null,
      onFilter: (value, record) => record.ipsLocationName === value,
      sorter: (a, b) => {
        a = a.ipsLocationName || '';
        b = b.ipsLocationName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'ipsLocationName' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'workOrder',
      width: '8%',
      key: 'workOrder',
      title: 'Install WO#',
      filters: composeFilters('workOrder', pceAssets),
      filteredValue: filteredInfo.workOrder || null,
      onFilter: (value, record) => record.workOrder === value,
      sorter: (a, b) => {
        a = a.workOrder || '';
        b = b.workOrder || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'workOrder' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'bpid',
      width: '8%',
      key: 'bpid',
      title: 'Install BPID',
      filters: composeFilters('bpid', pceAssets),
      filteredValue: filteredInfo.bpid || null,
      onFilter: (value, record) => record.bpid === value,
      sorter: (a, b) => {
        a = a.bpid || '';
        b = b.bpid || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'bpid' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'internalRef',
      width: '10%',
      key: 'internalRef',
      title: 'IPS Internal Ref. No.',
      filters: composeFilters('internalRef', pceAssets),
      filteredValue: filteredInfo.internalRef || null,
      onFilter: (value, record) => record.internalRef === value,
      sorter: (a, b) => {
        a = a.internalRef || '';
        b = b.internalRef || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'internalRef' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
    {
      dataIndex: 'assetStatus',
      width: '8%',
      key: 'assetStatus',
      title: 'IPS Asset Status',
      filters: composeFilters('assetStatus', pceAssets),
      filteredValue: filteredInfo.assetStatus || null,
      onFilter: (value, record) => record.assetStatus === value,
      sorter: (a, b) => {
        a = a.assetStatus || '';
        b = b.assetStatus || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      sortOrder: sortedInfo.columnKey === 'assetStatus' && sortedInfo.order,
      render: (text, record) => {
        return text;
      },
    },
  ];

  return (<div>
      <Accordion
        data={tracksData}
        project={project}
        seAssets={seAssets}
        pceAssets={pceAssets}
        onRowExpand={(rowId, isExpanded) => {
        }}
        onGroupExpand={(groupName, isExpanded) => {
        }}
        lcraStatus={lcraStatus}
        onAddClick={onAddClick}
        activeTab='asset'
        onDataRefreshed={onDataRefreshed}
        handleProjectDetailUpdate={handleProjectDetailUpdate}/>
      <Tabs defaultActiveKey="1"
            className='nav-B'
            type='card'
      >
        {/* Tab 1 */}
        <TabPane tab="SE Assests" key="1">
          <div className='container-fluid'>
            {/*<b>{this.state.project.stationName}</b>*/}
            <Row xs={24} style={{ alignItems: 'center', margin: '8px 0px' }}>
              <Col xs={18}>
                Here are the assets pulled for this project. Please review, and if
                there are any discrepancies, fix in IPS.
              </Col>
              <Col xs={6}>
                <h4>
                  <FMPDTAssetFileExport

                    projectInfo={projectInfo}
                    station={project.stationName}
                    apiCall={fmpAssetSEReviewExcelDownload}
                    fileStartingName={'SE Assets '}
                  />
                </h4>
              </Col>
            </Row>
            <Table
              className={'table-striped'}
              columns={seColumns}
              dataSource={seAssets.sort(multipleSort([iPSComp, assetNameComp]))}
              onChange={handleChange}
              loading={ refresh}

              pagination={{ showSizeChanger: false, pageSize: 10 }}
              scroll={{ x: 'max-content' }}
            />
          </div>
        </TabPane>
        <TabPane tab="PCE Assets" key="2">
          <div className='container-fluid'>
            {/*<b>{this.state.project.stationName}</b>*/}
            <Row xs={24} style={{ alignItems: 'center', margin: '8px 0px' }}>
              <Col xs={18}>
                Here are the assets pulled for this project. Please review, and if
                there are any discrepancies, fix in IPS.
              </Col>
              <Col xs={6}>
                <h4>
                  <FMPDTAssetFileExport

                      projectInfo={projectInfo}
                      station={project.stationName}
                      apiCall={fmpAssetPCEReviewExcelDownload}
                      fileStartingName={'PCE Assets '}
                  />
                </h4>
              </Col>
            </Row>
            <Table
                className={'table-striped'}
                columns={pceColumns}
                dataSource={pceAssets.sort(multipleSort([iPSComp, assetNameComp]))}
                onChange={handleChange}
                loading={ refresh}

                pagination={{ showSizeChanger: false, pageSize: 10 }}
                scroll={{ x: 'max-content' }}
            />
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default AssetReview;